import { FC, ReactNode } from "react";
import { Col, Row, Tag, Typography } from "antd";
import { StyledLink, StyledWrapperCard, StyledWrapperExtra } from "./styled";
import { ConditionalTooltipText } from "../ConditionalTooltipText";
import { EApproveStatus } from "../../types";
import { CalendatIcon } from "../icons/CalendatIcon";

interface IInfoCardProps {
  extraContent?: ReactNode;
  lastUpdated: string;
  previousPath?: string;
  redirectUrl: string;
  status: EApproveStatus;
  title: string;
}

export const InfoCard: FC<IInfoCardProps> = ({
  extraContent,
  lastUpdated,
  previousPath,
  redirectUrl,
  status,
  title,
}) => (
  <StyledLink data-testid="info-card" to={{ pathname: redirectUrl }}>
    <StyledWrapperCard>
      <Row
        className="row-first-child"
        align="middle"
        justify="space-between"
        wrap={false}
      >
        <ConditionalTooltipText text={title} />

        <Tag color={status === EApproveStatus.ACTUAL ? "#8c8c8c" : "#faad14"}>
          {status === EApproveStatus.ACTUAL ? "Актуально" : "Обновлено"}
        </Tag>
      </Row>

      <Row align="middle" gutter={8}>
        <Col>
          <CalendatIcon fill="#8c8c8c" />
        </Col>

        <Col>
          <Typography className="typography">
            {lastUpdated === "Invalid date"
              ? "Отсутствует дата изменения"
              : `РД изменена: ${lastUpdated}`}
          </Typography>
        </Col>
      </Row>
    </StyledWrapperCard>

    <StyledWrapperExtra>{extraContent}</StyledWrapperExtra>
  </StyledLink>
);
